// Loads GA4 (G-64KC440L1T) + Microsoft Clarity (brwk3687yu) + Meta Pixel
// (531294744483299) directly. Replaces GTM container GTM-KWQDFLD (removed).
//
// Prod only — mirrors the previous behaviour where GTM's id was set solely in
// the `env == 'prod'` block, so dev/local never sent to the shared GA4 property.
// All IDs match pl-www, pl-app and the blog, so every PhoneLive property now
// fires the identical GA4 + Clarity + Meta Pixel set with no GTM.
export default function () {
  if (typeof window === 'undefined') return
  var isProd = process.env.env === 'prod' || window.location.hostname === 'app.phonelivestreaming.com'
  if (!isProd) return

  // GA4
  var ga = document.createElement('script')
  ga.async = true
  ga.src = 'https://www.googletagmanager.com/gtag/js?id=G-64KC440L1T'
  document.head.appendChild(ga)
  window.dataLayer = window.dataLayer || []
  window.gtag = function () { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', 'G-64KC440L1T')

  // Microsoft Clarity
  ;(function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }
    t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y)
  })(window, document, 'clarity', 'script', 'brwk3687yu')

  // Meta Pixel — init + PageView
  ;(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }
    if (!f._fbq) f._fbq = n
    n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []
    t = b.createElement(e); t.async = !0; t.src = v
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  window.fbq('init', '531294744483299')
  window.fbq('track', 'PageView')
}
